<template>
    <article class="media note" :class="{ 'note-replying' : isReplying }">
        <figure class="media-left">
            <div class="image is-32x32">
                <div v-if="item.remind_at" class="note-avatar"><i class="icm-notification"></i></div>
                <img v-else :src="userAvatarById(item.actor_id)" class="note-avatar" >
            </div>
        </figure>
        <div class="media-content">
            <div class="content" :class="{'focusedContent' :  focusonload }" ref="noteContent">
                <strong>{{ actorNameByNote(item) }}</strong> -
                <small>{{ $filters.note_date(item.created_at) }}</small>
                <button class="delete" @click.prevent="handleRemove"/>
                <div>
                    <label v-if="item.reference_type === 'project'" style="cursor: pointer;">
                        <strong>Is Milestone:&nbsp;</strong>{{ item.is_milestone ? 'Yes' : 'No' }}

                        <o-checkbox v-show="false" :true-value="1" v-model="item.is_milestone" @input="handleUpdate">
                            <!--Milestone-->
                        </o-checkbox>
                    </label>
                </div>

                <div class="break-word" v-html="item.message"></div>
                <span v-if="item.remind_at"><strong>Remind At:</strong> {{ $filters.note_date(item.remind_at) }}</span><br>
                <template v-if="item.remind_at">
                <a href="#" @click.prevent="snoozeReminder" :class="{'not-active': sending}">Snooze</a>
                </template>
                <template v-else>
                <a href="#" @click.prevent="replyComment" :class="{'not-active': sending}" v-if="!isReplying">Reply</a>
                <a href="#" @click.prevent="cancelReply" :class="{'not-active': sending}" v-else>Cancel</a>
                </template>
                
            </div>
            <ul v-if="files.length">
                <li v-for="(file, key) in files" :key="key">
                    <span class="icon is-small">
                        <i class="fa fa-file"/>
                    </span>
                    <a :href="file.path" target="_blank">{{ file.name }}</a>
                    <span>{{ $filters.readableSize(file.size) }}</span>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
    import HandlesForm from '../mixins/HandlesForm'
    import {mapGetters, mapActions} from 'vuex'
    import ReminderModal from './modals/Reminder.vue'

    export default {
        mixins: [HandlesForm],

        props: ['item', 'isParentReplying', 'focusonload'],

        data() {
            return {
                sending: false,
                isReplying: false
            }
        },
        watch: {
            isParentReplying(val) {
                if(!val) {
                    this.isReplying = val
                }
            }
        },
        computed: {
            ...mapGetters([
                'filesByReference',
                'actorNameByNote',
                'userAvatarById',
                'userNameById',
                'noteById'
            ]),
            files() {
                return this.filesByReference('note', this.item.id)
            }
        },
        mounted() {
            if(this.focusonload) {
                setTimeout(() =>
                this.$refs.noteContent.scrollIntoView({ block: 'center',  behavior: 'smooth' }), 1000)
            }
        },
        methods: {
            ...mapActions(['updateNote', 'removeNote', 'removeReminder']),

            handleUpdate: _.debounce(function () {
                this.updateNote(this.item)
            }, 1000),

            replyComment() {
                this.isReplying = true
                this.$emit('reply', this.item)
            },
            cancelReply() {
                this.$emit('endreply', this.item)
                this.isReplying = false
            },

            handleRemove() {
                let typeItem = this.item.remind_at ? 'Reminder' : 'Note'
                this.confirmMessage(
                    `Deleting ${typeItem}`,
                    `Are you sure you want to <strong>delete</strong> this ${typeItem}? This action cannot be undone.`,
                    `Delete ${typeItem}`
                ).then(() => {

                    if(this.item.remind_at) {
                        this.removeReminder(this.item)
                    } else {
                        this.removeNote(this.item)
                    }
                })
            },
            snoozeReminder() {
                this.openModalComponent(ReminderModal, { reminderId: this.item.id })
            }
        }
    }
</script>
<style>
.note.media {
  border-top: none;
  margin-top: 10px;
  padding-top: 0px; }
.note.media .media-left {
  margin-right: 0px;
  padding: 8px 5px 10px 2px; }
.note.media .content {
  border: solid 1px #ccc;
  border-radius: 0px 6px 10px 6px;
  padding: 4px;
  background-color: #fff; }
.note.media .content.focusedContent {
  border: 2px dashed; }
.note.media .delete {
  float: right; }
.note.media div.note-avatar {
  width: 32px;
  height: 32px;
  background-color: green;
  padding: 7px 9px;
  color: white; }

</style>